import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ToastContainer } from "react-toastify";
import Login  from './auth/Login';
import Dashboard from './dashboard/Dashboard';
import Info from './Components/info';
import EL from './Components/ExpandedList';

import { Provider } from 'react-redux';
import Store from './../src/redux/store';


const App = () => {
  return (
    <>
      <Provider store={Store}>
        <div classNae="App">
          <Router>
            <Routes>
              <Route path="/" element={<Login />} />
              <Route path="/dashboard" element={<Dashboard/>} />
              <Route path="/info/:id" element={<Info />} />
              <Route path="/scheduled_today" element={<EL />} />
              <Route path="/scheduled_this_week" element={<EL />} />
              <Route path="/scheduled_next_week" element={<EL />} />
            </Routes>
          </Router>
        </div>
      </Provider>
    </>
  )
}

export default App;